// Kategori bazlı fiyatlandırma rehberi
// Amaç: Piyasa düzeni + eğitmen özgürlüğü dengesi

export const PRICING_GUIDE = {
  // Kayıtlı ders fiyat aralıkları (TL)
  recorded: {
    pilates: { min: 49, max: 199, recommended: 99 },
    yoga: { min: 49, max: 199, recommended: 99 },
    meditation: { min: 49, max: 199, recommended: 79 },
    fitness: { min: 49, max: 199, recommended: 99 },
    breathing: { min: 39, max: 149, recommended: 69 },
    mobility: { min: 39, max: 149, recommended: 69 }
  },
  // Canlı ders fiyat aralıkları (TL)
  live: {
    pilates: { min: 99, max: 349, recommended: 199 },
    yoga: { min: 99, max: 349, recommended: 199 },
    meditation: { min: 79, max: 299, recommended: 149 },
    fitness: { min: 99, max: 349, recommended: 199 },
    breathing: { min: 69, max: 249, recommended: 129 },
    mobility: { min: 69, max: 249, recommended: 129 }
  },
  // Canlı + Kayıt (canlı fiyatının %110'u önerilir)
  live_plus_recorded: {
    pilates: { min: 129, max: 399, recommended: 249 },
    yoga: { min: 129, max: 399, recommended: 249 },
    meditation: { min: 99, max: 349, recommended: 199 },
    fitness: { min: 129, max: 399, recommended: 249 },
    breathing: { min: 89, max: 299, recommended: 169 },
    mobility: { min: 89, max: 299, recommended: 169 }
  }
};

// Fiyat durumu kontrolü
export const getPriceStatus = (price, category, lessonType) => {
  const guide = PRICING_GUIDE[lessonType]?.[category];
  if (!guide) return { status: 'normal', message: '' };
  
  const priceNum = parseFloat(price);
  
  if (priceNum < guide.min) {
    return {
      status: 'low',
      message: `Bu fiyat önerilen aralığın altında (Min: ${guide.min}₺). Düşük fiyat algısını etkileyebilir.`,
      severity: 'warning'
    };
  }
  
  if (priceNum > guide.max) {
    return {
      status: 'high',
      message: `Bu fiyat önerilen aralığın üstünde (Max: ${guide.max}₺). Satış oranını etkileyebilir.`,
      severity: 'warning'
    };
  }
  
  if (priceNum === guide.recommended) {
    return {
      status: 'optimal',
      message: 'Önerilen fiyat! ✓',
      severity: 'success'
    };
  }
  
  return {
    status: 'normal',
    message: `Önerilen aralıkta (${guide.min}₺ - ${guide.max}₺)`,
    severity: 'info'
  };
};

// Kategori isimlerini Türkçe'ye çevir
export const getCategoryLabel = (category) => {
  const labels = {
    pilates: 'Pilates',
    yoga: 'Yoga',
    meditation: 'Meditasyon',
    fitness: 'Fitness',
    breathing: 'Nefes',
    mobility: 'Mobilite'
  };
  return labels[category] || category;
};

// Ders tipi isimlerini Türkçe'ye çevir
export const getLessonTypeLabel = (type) => {
  const labels = {
    recorded: 'Kayıtlı Ders',
    live: 'Canlı Ders',
    live_plus_recorded: 'Canlı + Kayıt'
  };
  return labels[type] || type;
};
